<mat-progress-bar
	[mode]="mode"
	[value]="fileUpload.progress"
	[color]="color"
></mat-progress-bar>
